export default __webpack_public_path__ + "static/media/hello_world_dapp.dd4159a4.md";